import * as React from 'react';
import { useEffect } from 'react';
import { sprig } from '@sprig-technologies/sprig-browser';
import { DashboardsApp } from 'apps/boards/src/dashboards-app';
import { useMountEffect } from 'common/hooks/useMountEffect';
import { getProjectId, getWorkspaceId } from 'common/report/util';
import { isProdEnv } from 'common/report/util/env';
import { AppLevelSpanIds, spans } from 'common/util/tracing';
import { DashboardsContext } from './util/context';

// for lazy load routes
// eslint-disable-next-line import/no-default-export
export default () => {
  const projectId = parseInt(getProjectId(), 10);
  const workspaceId = parseInt(getWorkspaceId());
  const dashboardContext = new DashboardsContext({
    projectId,
    workspaceId
  });
  const {
    userId,
    userEmail
  } = dashboardContext;
  useMountEffect(() => {
    spans.getOrCreateAppLevelSpan(AppLevelSpanIds.BOARDS);
    return () => {
      spans.endSpanById(AppLevelSpanIds.BOARDS);
    };
  });
  useEffect(() => {
    const Sprig = sprig.configure({
      environmentId: isProdEnv() ? "9sZai6GO-WSS" : "nwR-Y3CwEnJH"
    });
    Sprig.setUserId(userId === null || userId === void 0 ? void 0 : userId.toString());
    Sprig.setEmail(userEmail);
  }, [userId, userEmail]);
  return <DashboardsApp context={dashboardContext} />;
};